import { render } from "./ButtonVue.vue?vue&type=template&id=6b45e8a8&scoped=true"
import script from "./ButtonVue.vue?vue&type=script&lang=js"
export * from "./ButtonVue.vue?vue&type=script&lang=js"

import "./ButtonVue.vue?vue&type=style&index=0&id=6b45e8a8&scoped=true&lang=scss"

import exportComponent from "../../fin_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b45e8a8"]])

export default __exports__